import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { backend } from "../../../../path";
import styled, { keyframes } from "styled-components";
import "./contact.css";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_no: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    phone_no: "",
  });
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com)$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\+?\d{1,13}$/;
    return phoneRegex.test(phone);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: validateEmail(value)
          ? ""
          : "Invalid email format (e.g., example@gmail.com)",
      }));
    }

    if (name === "phone_no") {
      const filteredValue = value.replace(/[^+\d]/g, "");
      if (filteredValue.length > 13) return;
      setFormData((prev) => ({ ...prev, phone_no: filteredValue }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        phone_no: validatePhone(filteredValue)
          ? ""
          : "Invalid phone number (Max 13 digits, only + allowed)",
      }));
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = () => {
    const requiredFields = ["name", "email", "phone_no", "message"];
    const emptyFields = requiredFields.filter((field) => !formData[field]);

    if (emptyFields.length > 0) {
      toast.error("Please fill in all required fields", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Prevent further execution
    }

    fetch(backend + "contactus", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to submit form:",
            response.status,
            response.statusText
          );
          toast.error("Failed to submit form. Please try again later", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return;
        }
        // Reset form after successful submission
        setFormData({
          name: "",
          email: "",
          phone_no: "",
          message: "",
        });
        toast.success("Form submitted successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        toast.error("Failed to submit form. Please try again later", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  return (
    <main>
      <div className="page-header breadcrumb-wrap">
        <div className="container">
          <div className="breadcrumb">
            <a href="/" className="breadcrumb-item d-inline-block" title="Home">
              {" "}
              Home{" "}
            </a>
            <span></span>
            <div className="breadcrumb-item d-inline-block active">
              {" "}
              Contact Us{" "}
            </div>
          </div>
        </div>
      </div>
      <PageWrapper>
        <HeroSection>
          <HeroContent>
            <HeroBadge>KeralaSpecial.in</HeroBadge>
            <HeroTitle>Get in Touch</HeroTitle>
            <HeroSubtitle>
              We’re here to help you experience the essence of Kerala.
            </HeroSubtitle>
            <Paragraph>
              Whether you have a question, need support, or want to collaborate,
              our team is ready to assist. Reach out through the form or connect
              with us directly using the details provided.
            </Paragraph>
            <ContactGrid>
              <ContactCard>
                <CardTitle>Visit Us</CardTitle>
                <SmallParagraph>
                  38, Thycaud Elankom Nagar,
                  <br /> Thycaud, Trivandrum 695014
                </SmallParagraph>
              </ContactCard>
              <ContactCard>
                <CardTitle>Call Us</CardTitle>
                <SmallParagraph>
                  (91)-7356629493
                  <br /> 8891196910
                </SmallParagraph>
              </ContactCard>
              <ContactCard>
                <CardTitle>Email Us</CardTitle>
                <SmallParagraph>
                  <a href="mailto:info@keralaspecial.in">info@keralaspecial.in</a>
                </SmallParagraph>
              </ContactCard>
            </ContactGrid>
          </HeroContent>
          <HeroVisual>
            <HeroImage
              src="/storage/general/contact.png"
              alt="KeralaSpecial team"
            />
            <HeroOverlayCard>
              <OverlayTitle>We're Listening</OverlayTitle>
              <OverlaySubtitle>Share how we can assist you today.</OverlaySubtitle>
            </HeroOverlayCard>
          </HeroVisual>
        </HeroSection>

        <SupportSection>
          <SectionHeader>
            <SectionTitle>Contact Our Support Team</SectionTitle>
            <Paragraph>
              We strive to provide an exceptional experience that reflects the
              warmth and hospitality of Kerala. Let us know how we can make your
              journey even better.
            </Paragraph>
          </SectionHeader>
          <SupportGrid>
            <Highlights>
              <HighlightCard>
                <HighlightTitle>Prompt Assistance</HighlightTitle>
                <Paragraph>
                  Our support specialists are dedicated to resolving your
                  queries quickly and effectively, ensuring you feel valued at
                  every step.
                </Paragraph>
              </HighlightCard>
              <HighlightCard>
                <HighlightTitle>Curated Guidance</HighlightTitle>
                <Paragraph>
                  Need help choosing the perfect Kerala experience? We provide
                  personalised recommendations tailored to your interests.
                </Paragraph>
              </HighlightCard>
              <HighlightCard>
                <HighlightTitle>Community First</HighlightTitle>
                <Paragraph>
                  Your feedback helps us uplift artisans and keep Kerala’s rich
                  traditions alive. Reach out—we’d love to hear from you.
                </Paragraph>
              </HighlightCard>
            </Highlights>
            <FormCard>
              <FormTitle>Send Us a Message</FormTitle>
              <Paragraph style={{ marginBottom: "24px" }}>
                Fill in your details and let us know how we can support you. Our
                team will get back to you shortly.
              </Paragraph>
              <Form>
                <div className="box">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="box">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <ErrorText>{errors.email}</ErrorText>}
                </div>
                <div className="box">
                  <label htmlFor="phone_no">Phone Number</label>
                  <input
                    type="text"
                    id="phone_no"
                    name="phone_no"
                    value={formData.phone_no}
                    onChange={handleChange}
                    required
                  />
                  {errors.phone_no && <ErrorText>{errors.phone_no}</ErrorText>}
                </div>
                <div className="box">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <SubmitButton
                  type="button"
                  onClick={handleSubmit}
                  disabled={Boolean(errors.email || errors.phone_no)}
                >
                  Submit Message
                </SubmitButton>
              </Form>
            </FormCard>
          </SupportGrid>
        </SupportSection>
      </PageWrapper>
    </main>
  );
}

export default ContactUs;
const pageFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const floatPulse = keyframes`
  0% {
    transform: translateY(0);
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.2);
  }
  50% {
    transform: translateY(-6px);
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.28);
  }
  100% {
    transform: translateY(0);
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.2);
  }
`;

const badgeGlow = keyframes`
  from {
    box-shadow: 0 0 0 rgba(98, 188, 1, 0.0);
  }
  to {
    box-shadow: 0 10px 24px rgba(98, 188, 1, 0.35);
  }
`;

const PageWrapper = styled.div`
  max-width: 90vw;
  margin: 0 auto;
  padding: 0 24px 96px;
  opacity: 0;
  animation: ${pageFadeIn} 0.7s ease forwards;
`;

const HeroSection = styled.section`
  margin-top: 64px;
  background: linear-gradient(135deg, #fff7ea 0%, #ffffff 60%);
  border-radius: 32px;
  padding: 48px 56px;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 40px;
  align-items: center;
  box-shadow: 0 40px 80px rgba(16, 24, 40, 0.08);
  opacity: 0;
  animation: ${fadeInScale} 0.8s ease forwards;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    padding: 40px 32px;
  }

  @media screen and (max-width: 640px) {
    padding: 32px 24px;
    margin-top: 40px;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  opacity: 0;
  animation: ${fadeInUp} 0.9s ease forwards;
  animation-delay: 0.1s;
`;

const HeroBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(98, 188, 1, 0.15);
  color: #2f6f26;
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  font-size: 12px;
  width: fit-content;
  animation: ${badgeGlow} 2.6s ease-in-out infinite alternate;
`;

const HeroTitle = styled.h1`
  font-size: 48px;
  line-height: 1.1;
  margin: 0;
  color: #111827;
  opacity: 0;
  animation: ${fadeInUp} 0.9s ease forwards;
  animation-delay: 0.18s;

  @media screen and (max-width: 768px) {
    font-size: 36px;
  }
`;

const HeroSubtitle = styled.h3`
  margin: 0;
  font-size: 20px;
  color: #62bc01;
  font-weight: 600;
  opacity: 0;
  animation: ${fadeInUp} 0.9s ease forwards;
  animation-delay: 0.24s;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

const Paragraph = styled.p`
  margin: 0;
  color: #374151;
  line-height: 1.7;
  font-size: 16px;
  opacity: 0;
  animation: ${fadeInUp} 0.9s ease forwards;
  animation-delay: 0.3s;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-top: 24px;

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }

  /* staggered animation */
  & > div {
    opacity: 0;
    transform: translateY(24px);
    animation: ${fadeInUp} 0.8s ease forwards;
  }

  & > div:nth-child(2) {
    animation-delay: 0.15s;
  }

  & > div:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

const ContactCard = styled.div`
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
`;

const CardTitle = styled.h4`
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
`;

const SmallParagraph = styled(Paragraph)`
  font-size: 15px;
`;

const HeroVisual = styled.div`
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background: #111827;
  min-height: 360px;
  opacity: 0;
  animation: ${fadeInRight} 0.9s ease forwards;
  animation-delay: 0.2s;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const HeroOverlayCard = styled.div`
  position: absolute;
  bottom: 24px;
  left: 24px;
  right: 24px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 20px;
  padding: 18px 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.25);
  backdrop-filter: blur(6px);
  animation: ${floatPulse} 5s ease-in-out infinite;
`;

const OverlayTitle = styled.h5`
  margin: 0;
  font-size: 16px;
  color: #111827;
  font-weight: 600;
`;

const OverlaySubtitle = styled.p`
  margin: 4px 0 0;
  color: #4b5563;
  font-size: 14px;
`;

const SupportSection = styled.section`
  margin-top: 96px;
  display: flex;
  flex-direction: column;
  gap: 48px;
  opacity: 0;
  animation: ${fadeInUp} 0.9s ease forwards;
  animation-delay: 0.35s;
`;

const SectionHeader = styled.div`
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  text-transform: uppercase;
  color: #0f172a;
  letter-spacing: 1.2px;

  @media screen and (max-width: 768px) {
    font-size: 26px;
  }
`;

const SupportGrid = styled.div`
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 32px;

  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const Highlights = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  & > div {
    opacity: 0;
    transform: translateY(28px);
    animation: ${fadeInUp} 0.85s ease forwards;
  }

  & > div:nth-child(2) {
    animation-delay: 0.15s;
  }

  & > div:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

const HighlightCard = styled.div`
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 22px 48px rgba(15, 23, 42, 0.16);
  }
`;

const HighlightTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
`;

const FormCard = styled.div`
  background: linear-gradient(135deg, #62bc01 0%, #3a7d16 100%);
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  gap: 24px;
  opacity: 0;
  animation: ${fadeInRight} 0.95s ease forwards;
  animation-delay: 0.25s;

  @media screen and (max-width: 640px) {
    padding: 28px;
  }
`;

const FormTitle = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  opacity: 0;
  animation: ${fadeInUp} 0.85s ease forwards;
  animation-delay: 0.4s;
`;

const Form = styled.form`
  display: grid;
  gap: 18px;

  label {
    color: #f9fafb;
    font-weight: 500;
    opacity: 0;
    animation: ${fadeInUp} 0.8s ease forwards;
    animation-delay: 0.45s;
  }

  input,
  textarea {
    padding: 12px 18px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.35);
    background: rgba(255, 255, 255, 0.08);
    color: #f9fafb;
    transition: border 0.3s ease, background 0.3s ease;
    opacity: 0;
    animation: ${fadeInUp} 0.8s ease forwards;
    animation-delay: 0.5s;
  }

  input::placeholder,
  textarea::placeholder {
    color: rgba(249, 250, 251, 0.6);
  }

  input:focus,
  textarea:focus {
    outline: none;
    border: 1px solid rgba(255, 255, 255, 0.8);
    background: rgba(255, 255, 255, 0.16);
  }

  textarea {
    resize: vertical;
  }
`;

const ErrorText = styled.p`
  margin: 6px 0 0;
  color: #ffe5e5;
  font-size: 12px;
  opacity: 0;
  animation: ${fadeInUp} 0.6s ease forwards;
  animation-delay: 0.55s;
`;

const SubmitButton = styled.button`
  margin-top: 8px;
  height: 48px;
  border-radius: 999px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background: #ffffff;
  color: #14532d;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  opacity: 0;
  animation: ${fadeInUp} 0.85s ease forwards;
  animation-delay: 0.6s;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 24px rgba(10, 32, 15, 0.25);
  }
`;
